// DEMO MODE — no Supabase SDK, no network calls.
// Pure in-memory mock that mimics the Supabase client interface.

const FAKE_SESSION = {
  user: { id: 'demo-user-001', email: 'demo@tessbuddy.app', role: 'authenticated' },
  access_token: 'demo-token',
  expires_at: Date.now() / 1000 + 86400
}

let _listeners = []
let _session = null
let _usage = { credits: 47, allowance: 500 }

function tableClient(table) {
  const chain = {
    select: () => chain,
    eq: () => chain,
    single: async () => {
      if (table === 'user_profiles') {
        return {
          data: {
            display_name: 'Demo Admin',
            role: 'Admin',
            org_id: 1,
            hygiene: 1,
            screening: 1,
            segment: 1,
            is_active: true
          },
          error: null
        }
      }
      if (table === 'organizations') {
        return {
          data: {
            org_id: 1,
            org_name: 'Demo Organization',
            tessitura_base_url: 'https://demo.tessbuddy.app/TessituraService',
            tessitura_auth_string: 'DEMO'
          },
          error: null
        }
      }
      if (table === 'usage') {
        return { data: _usage, error: null }
      }
      return { data: null, error: { message: 'Not found' } }
    },
    maybeSingle: async () => {
      if (table === 'usage') return { data: _usage, error: null }
      return chain.single()
    },
    update: (values) => ({
      eq: async () => {
        if (table === 'usage') {
          _usage = { ..._usage, ...values }
          return { data: _usage, count: 1, error: null }
        }
        return { data: null, count: 0, error: null }
      }
    }),
    insert: async (values) => {
      if (table === 'usage') {
        _usage = { ..._usage, ...(Array.isArray(values) ? values[0] : values) }
        return { data: _usage, error: null }
      }
      return { data: null, error: null }
    }
  }
  return chain
}

export const supabase = {
  auth: {
    signInWithPassword: async ({ password }) => {
      await new Promise(r => setTimeout(r, 600))
      if (password !== 'Testing1234!') {
        return { data: { session: null }, error: { message: 'Incorrect password.' } }
      }
      _session = { ...FAKE_SESSION }
      setTimeout(() => _listeners.forEach(cb => cb('SIGNED_IN', _session)), 0)
      return { data: { session: _session }, error: null }
    },
    signOut: async () => {
      _session = null
      _listeners.forEach(cb => cb('SIGNED_OUT', null))
      return { error: null }
    },
    onAuthStateChange: (callback) => {
      _listeners.push(callback)
      setTimeout(() => callback(_session ? 'SIGNED_IN' : 'INITIAL_SESSION', _session), 50)
      return {
        data: {
          subscription: {
            unsubscribe: () => { _listeners = _listeners.filter(cb => cb !== callback) }
          }
        }
      }
    },
    getSession: async () => ({ data: { session: _session }, error: null }),
    updateUser: async () => ({ data: { user: FAKE_SESSION.user }, error: null }),
    resetPasswordForEmail: async () => ({ data: {}, error: null })
  },
  from: tableClient
}
